import { useCallback, useEffect, useLayoutEffect, useRef } from 'react'
import { i18n } from '@fs/zion-locale'
import { useStatusOverlay } from '@fs/zion-ui'
import logError from '../services/logError'

function formatGenericErrorMessage() {
  return i18n.t('generic.error', 'Something went wrong, try again later')
}

export default function useShowError(errorReturnProp) {
  const showStatusOverlay = useStatusOverlay()
  // useRef with useLayoutEffect to avoid returning a new reportError function
  // on every render. This way we don't have to depend on useStatusOverlay's
  // implementation. Recipe from: https://epicreact.dev/how-react-uses-closures-to-avoid-bugs
  const showStatusOverlayRef = useRef(showStatusOverlay)
  useLayoutEffect(() => {
    showStatusOverlayRef.current = showStatusOverlay
  })
  const reportError = useCallback(function reportError(error, formattedMessage) {
    const message = formattedMessage || formatGenericErrorMessage()
    showStatusOverlayRef.current({
      message,
      type: 'error',
    })
    logError(`showError called with ${error}`)
  }, [])
  useEffect(() => {
    if (errorReturnProp?.message) {
      reportError(errorReturnProp?.message)
    }
  }, [errorReturnProp?.message, reportError])
  return reportError
}
